import { faXmark, faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect, useCallback } from 'react';
import '../../assets/Helpers.css';


const Alert = ({ onDismiss }) => {
    const [isVisible, setIsVisible] = useState(false);
    const [alertData, setAlertData] = useState({ status: null, message: '' });

    // Function to show alert - can be called from parent component
    const showAlert = useCallback((status, message) => {
        setAlertData({ status, message });
        setIsVisible(true);
        
        // Auto-dismiss after 6 seconds
        setTimeout(() => {
            setIsVisible(false);
            if (onDismiss) {
                onDismiss();
            }
        }, 6000);
    }, [onDismiss]);

    // Expose showAlert function to parent component
    useEffect(() => {
        window.showAlert = showAlert;
    }, [showAlert]);

    if (!isVisible || !alertData.status || !alertData.message) return null;

    // Determine alert type and styling based on status code
    const getAlertType = (status) => {
        if (status >= 200 && status < 300) {
            return {
                type: 'success',
                icon: faCheckCircle,
                className: 'alert-success'
            };
        } else if (status === 404) {
            return {
                type: 'warning',
                icon: faExclamationTriangle,
                className: 'alert-warning'
            };
        } else {
            return {
                type: 'error',
                icon: faTimesCircle,
                className: 'alert-error'
            };
        }
    };

    const alertType = getAlertType(alertData.status);

    const handleClose = () => {
        setIsVisible(false);
        if (onDismiss) {
            onDismiss();
        }
    };

    return (
        <div className="alert-overlay">
            <div className={`alert-content ${alertType.className}`}>
                <button 
                    className="alert-close-button"
                    onClick={handleClose}
                >
                    <FontAwesomeIcon icon={faXmark} />
                </button>
                
                <div className="alert-header">
                    <FontAwesomeIcon icon={alertType.icon} className="alert-icon" />
                    <h3 className="alert-title">
                        {alertType.type === 'success' && 'Success'}
                        {alertType.type === 'warning' && 'Warning'}
                        {alertType.type === 'error' && 'Error'}
                    </h3>
                </div>
                
                <div className="alert-body">
                    <p className="alert-message">{alertData.message}</p>
                    <p className="alert-status">Status: {alertData.status}</p>
                </div>
                
                <div className="alert-actions">
                    <button 
                        className="alert-button"
                        onClick={handleClose}
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};

export default Alert;
